import _ from 'lodash';
import { useContext } from 'react';
import Icons from '../../../../../common/widgets/Icons';
import PopoverDialog from '../../../../../common/widgets/PopoverDialog';
import { CustomerInfoContext } from '../../../../benefit/contexts/CustomerInfoContext';
import { config } from '../../../config';

export default function Language() {
  const { customerInfo } = useContext(CustomerInfoContext);

  const onLanguageChange = (lang: string) => {
    const currentLang = customerInfo?.languageCode ?? config.defaultLanguage;

    if (lang != currentLang) {
      window.localStorage.setItem('language', lang);
      location.reload();
    }
  };

  return (
    <>
      <PopoverDialog
        className="dropdown-menu-list m-header-dropdown m-language-dropdown"
        placement="bottom"
        closeFromContent
        type="hover"
        content={<LanguageMenu onLanguageChange={onLanguageChange} />}
      >
        <a
          className="btn app-bar-tools-btn app-bar-language"
          onClick={() => {
            const lang = config.languages.find(
              l => l != (customerInfo?.languageCode ?? config.defaultLanguage),
            );
            if (lang) {
              onLanguageChange(lang);
            }
          }}
        >
          <span className="btn-icon">
            <Icons.Language />
          </span>
          <span className="btn-text">
            {(
              customerInfo?.languageCode ?? config.defaultLanguage
            )?.toUpperCase()}
          </span>
        </a>
      </PopoverDialog>
    </>
  );
}

interface ILanguageMenuProps {
  onLanguageChange: (language: string) => void;
}

interface LanguageMenuItem {
  text: string;
  onClick(): void;
}

const LanguageMenu = (props: Readonly<ILanguageMenuProps>) => {
  const menuItems: LanguageMenuItem[] = config.languages.map(language => ({
    text: language,
    onClick: () => props.onLanguageChange(language),
  }));

  return (
    <ul>
      {_.map(menuItems, ({ onClick, text }) => (
        <li key={text}>
          <a onClick={onClick}>{text.toUpperCase()}</a>
        </li>
      ))}
    </ul>
  );
};
